// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BuyCard-root-72c8{min-width:120px;max-width:160px;flex:1 1 0}`, "",{"version":3,"sources":["webpack://./src/page/InferenceScreen/buy/BuyCard.module.scss"],"names":[],"mappings":"AAAA,mBACE,eAAA,CACA,eAAA,CACA,UAAA","sourcesContent":[".root {\n  min-width: 120px;\n  max-width: 160px;\n  flex: 1 1 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `BuyCard-root-72c8`
};
module.exports = ___CSS_LOADER_EXPORT___;
